// @flow

import React from 'react';
import styled from 'styled-components';

import { Logo as LogoData } from 'data/global/nav';
import { flex, hoverChild, Color, hover, Width } from 'styles';
import { usePageState } from 'contexts';
import { LogoMarkets } from 'components/Svg';
import { Link } from 'components/Gui';
import Social from './Social';

const Wrapper = styled.div`
  ${flex('space-between', 'flex-start')};
  flex-direction: column;

  @media (min-width: ${Width.BREAK_MD}px) {
    flex-direction: row;
    align-items: center;
  }
  > div.links {
    ${flex('flex-start', 'flex-start')};
    margin-bottom: 20px;

    @media (min-width: ${Width.BREAK_MD}px) {
      margin-bottom: 0;
    }

    .logo {
      svg {
        width: 120px;
        ${hoverChild('path, rect, polygon', 'fill', Color.WHITE, Color.MARKETS_GREEN)};
      }
    }

    > div {
      ${flex('flex-start', 'flex-start')};
      flex-direction: column;
      margin-left: 24px;

      span {
        color: white;
        margin-bottom: 3px;

        a {
          ${hover('color', Color.WHITE, Color.MARKETS_GREEN)};
        }
      }
    }
  }
`;

const CompanyInfo = () => {
  const {
    footerConfig: { toggleHidden },
  } = usePageState();
  return !toggleHidden.companyInfo ? (
    <Wrapper>
      <div className="links">
        <Link className="logo" {...LogoData}>
          {LogoMarkets}
        </Link>
        <div>
          <span>
            t. <Link url="tel:1-800-884-8592">1.800.884.8592</Link>
          </span>
          <span>
            t. <Link url="tel:+356-2792-2004">+356-2792-2004</Link>
          </span>
          <span>
            e. <Link url="mailto:support@marketsdirect.com">support@marketsdirect.com</Link>
          </span>
        </div>
      </div>
      <Social />
    </Wrapper>
  ) : null;
};

export default CompanyInfo;
